module.exports = __webpack_public_path__ + "static/img/int2.6ca4b8d6.jpg";